import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../lib/LanguageContext';
import { translations } from '../../lib/translations';
export function EnablesSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const titleRef = useRef<HTMLDivElement>(null);
  const titleInView = useInView(titleRef, {
    once: true,
    margin: '-80px'
  });
  const {
    lang
  } = useLanguage();
  const t = translations[lang].enables;
  return <section style={{
    width: '100%',
    backgroundColor: 'var(--black)',
    color: 'var(--white)',
    padding: '10rem 1.5rem'
  }} data-id="element-201">
      <div style={{
      maxWidth: '56rem',
      margin: '0 auto'
    }} data-id="element-202">
        {/* Section label */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} style={{
        fontFamily: '"IBM Plex Mono", monospace',
        fontSize: '0.65rem',
        letterSpacing: '0.3em',
        textTransform: 'uppercase',
        color: 'var(--grey-500)',
        marginBottom: '3rem'
      }} data-id="element-203">
          {t.label}
        </motion.p>

        {/* Title */}
        <motion.div ref={titleRef} initial={{
        opacity: 0,
        y: 20
      }} animate={titleInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} style={{
        marginBottom: '6rem'
      }} data-id="element-204">
          <h2 style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: 700,
          fontSize: 'clamp(1.75rem, 4vw, 3rem)',
          color: 'var(--white)',
          lineHeight: 1.15,
          letterSpacing: '-0.01em',
          margin: 0
        }} data-id="element-205">
            {t.title}
          </h2>
        </motion.div>

        {/* Three columns */}
        <div ref={ref} style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        borderTop: '1px solid rgba(255,255,255,0.08)'
      }} data-id="element-206">
          {t.cols.map((col, colIdx) => <motion.div key={colIdx} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: colIdx * 0.12
        }} style={{
          padding: colIdx === 0 ? '3rem 2.5rem 3rem 0' : colIdx === t.cols.length - 1 ? '3rem 0 3rem 2.5rem' : '3rem 2.5rem',
          borderRight: colIdx < t.cols.length - 1 ? '1px solid rgba(255,255,255,0.08)' : undefined
        }} data-id="element-207">
              <h3 style={{
            fontFamily: '"IBM Plex Sans", sans-serif',
            fontWeight: 700,
            fontSize: 'clamp(1rem, 2vw, 1.25rem)',
            color: 'var(--red)',
            marginBottom: '2rem',
            lineHeight: 1.2
          }} data-id="element-208">
                {col.heading}
              </h3>
              <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0
          }} data-id="element-209">
                {col.items.map((item, itemIdx) => <li key={itemIdx} style={{
              display: 'flex',
              gap: '0.75rem',
              alignItems: 'flex-start',
              paddingBottom: '0.5rem'
            }} data-id="element-210">
                    <span style={{
                color: 'rgba(255,255,255,0.2)',
                fontFamily: '"IBM Plex Mono", monospace',
                fontSize: '0.7rem',
                paddingTop: '0.3rem',
                flexShrink: 0
              }} data-id="element-211">
                      —
                    </span>
                    <span style={{
                fontFamily: '"IBM Plex Sans", sans-serif',
                fontWeight: 300,
                fontSize: '0.9375rem',
                color: 'rgba(255,255,255,0.6)',
                lineHeight: 1.7
              }} data-id="element-212">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        {/* Final closing */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.3
      }} style={{
        borderTop: '1px solid rgba(255,255,255,0.08)',
        paddingTop: '4rem',
        marginTop: '2rem',
        textAlign: 'center'
      }} data-id="element-213">
          <p style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: 300,
          fontSize: 'clamp(1.1rem, 2.5vw, 1.4rem)',
          color: 'rgba(255,255,255,0.5)',
          lineHeight: 1.75,
          maxWidth: '36rem',
          margin: '0 auto'
        }} data-id="element-214">
            {t.closing1}
            <br data-id="element-215" />
            {t.closing2}
            <br data-id="element-216" />
            {t.closing3}
            <span style={{
            fontWeight: 700,
            color: 'var(--white)'
          }} data-id="element-217">
              {t.closing4}
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}